export enum ClientChoreClientOption {
  required = 'required',
  optional = 'optional',
  notAllowed = 'not_allowed',
}
